# An abstraction around session/local storage
#
# If session/local storage is available then we use on of this. If the uses has
# asked to be "remembered" then we choose localStorage. If these are not
# available we use an InProcStore which will only persist until another page
# load happens.

angular.module('wbServices').factory 'storage', ['$cookies', (cookies) ->
  isLocalStorageNameSupported = ->
    testKey = 'testLocalStorageNameSupported'
    try
      storage = window.localStorage
      storage.setItem(testKey, '1')
      storage.removeItem(testKey)
      true
    catch
      false

  class CookieStore
    constructor: (cookies) -> @cookies = cookies
    getItem: (key) => @cookies.get(key) || null
    setItem: (key, value) => @cookies.put(key, value)
    removeItem: (key) => @cookies.remove(key)

  class Storage
    storage: ->
      if isLocalStorageNameSupported then localStorage else sessionStorage

    getItem: (key) => @storage().getItem(key)

    setItem: (key, value) =>
      @storage().setItem(key, value)

    removeItem: (key) => @storage().removeItem(key)

  if isLocalStorageNameSupported()
    new Storage()
  else
    new CookieStore(cookies)
]
